import script from "./FileTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileTable.vue?vue&type=script&setup=true&lang=ts"

import "./FileTable.vue?vue&type=style&index=0&id=d567da46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d567da46"]])

export default __exports__